import { useState, useEffect } from 'react';
import moment from 'moment';
import { http } from '../core/Api';

export const useServerTime = () => {
  const [serverTime, setServerTime] = useState(null);

  useEffect(() => {
    try {
      const before = new Date();
      http(`api/backend/v2/time`, 'GET').then((response) => {
        const after = new Date();

        const diff = after - before;
        setServerTime(moment(response).valueOf() + diff);
      });
    }
    catch (e) {
    }
  }, []);

  return [serverTime, setServerTime];
};

export const getServerTime = async () => {
  try {
    const before = new Date();
    const serverTime = await http(`api/backend/v2/time`, 'GET');
    const after = new Date();
    const diff = after - before;
    return serverTime + diff;
  }
  catch (e) {
  }
};

export const useSimuladao = () => {
  const [simuladao, setSimuladao] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    try {
      http(`api/backend/v2/scholarshipcontest`, 'GET').then((response) => {
        if(!response.error) {
          setSimuladao(response);
        }
        setLoading(false);
      });
    }
    catch (e) {
      setSimuladao(null);
      setLoading(false);
    }
  }, []);

  return [simuladao, setSimuladao, isLoading];
};

export const useOpenSimuladao = (simulated, redirect) => {
  const [simuladao, setSimuladao] = useState(null);
  const [history, setHistory] = useState({});
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    try {
      let rout = `api/backend/v2/scholarshipcontest/verify/started`;
      http(rout, 'POST', { simulated: simulated }).then((response) => {
        if(!response.simulated) {
          redirect.push(`/${simulated}`);
        }

        if(!response.error) {
          setHistory(response.history);
          setSimuladao(response.simulated);
        }
        setLoading(false);
      });
    }
    catch (e) {
      setSimuladao(null);
      setLoading(false);
      redirect.push(`/${simulated}`);
    }
  }, []);

  return [simuladao, setSimuladao, history, setHistory, isLoading];
};

export const goToSimuladao = (user, history) => {
  history.push('/');
};

export const verifyLinkSimulation = (rankingEndDate) =>
  new Date(rankingEndDate) <= new Date();

export function generateUUID() {
  let d = new Date().getTime();
  let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16;//random number between 0 and 16
    if(d > 0) {//Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
